import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=22c4dc1e&"
import script from "./categories.vue?vue&type=script&lang=js&"
export * from "./categories.vue?vue&type=script&lang=js&"
import style0 from "./categories.vue?vue&type=style&index=0&id=22c4dc1e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c4dc1e')) {
      api.createRecord('22c4dc1e', component.options)
    } else {
      api.reload('22c4dc1e', component.options)
    }
    module.hot.accept("./categories.vue?vue&type=template&id=22c4dc1e&", function () {
      api.rerender('22c4dc1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/categorylist/categories.vue"
export default component.exports